import { IEventMetadata, IFormFieldMetadata, IFormFieldValueMetadata, IFormMetadata, IFormSectionMetadata, IFormVersionMetadata, ITrial, ResponseStatus } from "@/api/dtos";
import { ISourceDataReviewCounts } from "@/hooks/form/useSourceDataReviewCounts";
import { ISourceDataFormLayoutComponents, ISourceDataFormSettings, ISourceDataVerificationEvent, ISourceDataVerificationItem } from "@/utilities/forms/SourceDataFormProcessor";
import { Observable } from "@ngt/forms-core";
import { createContext } from "react"

export const SourceDataReviewCountsContext = createContext<ISourceDataReviewCounts>({
    identifier: {},
    review: {
        reviewed: 0,
        verified: 0,
        totalToReview: 0,
        totalToVerify: 0,
        total: 0
    }
});

export default SourceDataReviewCountsContext;